import LoadingOverlay from './LoadingOverlay'

export default function TMHLoader({ active = false, children, text = "Loading..." }) {
    return (
        <LoadingOverlay
            active={active}
            spinner={true}
            text={text}
        >
            {children}
        </LoadingOverlay>
    )
}